import ymapsloader from 'ymaps'

window.Drupal.loadMap = async () => {
    const ymaps = await ymapsloader.load("https://api-maps.yandex.ru/2.1/?apikey=8c55a365-8aa5-4f3b-b745-be4e0b7e26e9&lang=ru_RU")
    window.Drupal.ymaps = ymaps;
    const MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="map__balloon top">' +
        '<div id="close" class="map__balloon__close"></div>' +
        '<div id="arrow" class="map__balloon__arrow"></div>' +
        '<div class="map__balloon__inner">' +
        "$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]" +
        "</div>" +
        "</div>",
        {
            build: function () {
                this.constructor.superclass.build.call(this);

                this._$element = this.getParentElement().querySelector(".map__balloon");

                this.applyElementOffset();

                this._$element
                    .querySelector("#close")
                    .addEventListener("click", this.onCloseClick.bind(this));
            },
            clear: function () {
                this._$element
                    .querySelector("#close")
                    .removeEventListener("click", this.onCloseClick);

                this.constructor.superclass.clear.call(this);
            },
            onSublayoutSizeChange: function () {
                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                if (!this._isElement(this._$element)) {
                    return;
                }

                this.applyElementOffset();

                this.events.fire("shapechange");
            },
            applyElementOffset: function () {
                this._$element.style.left = -(this._$element.offsetWidth / 2) + "px";
                this._$element.style.top =
                    -(
                        this._$element.offsetHeight +
                        this._$element.querySelector("#arrow").offsetHeight
                    ) + "px";
            },
            onCloseClick: function (e) {
                e.preventDefault();

                this.events.fire("userclose");
            },
            getShape: function () {
                if (!this._isElement(this._$element)) {
                    return MyBalloonLayout.superclass.getShape.call(this);
                }

                return new ymaps.shape.Rectangle(
                    new ymaps.geometry.pixel.Rectangle([
                        [this._$element.offsetLeft, this._$element.offsetTop],
                        [
                            this._$element.offsetLeft + this._$element.offsetWidth,
                            this._$element.offsetTop +
                            this._$element.offsetHeight +
                            this._$element.querySelector("#arrow").offsetHeight
                        ]
                    ])
                );
            },
            _isElement: function (element) {
                return element && element.querySelector("#arrow");
            }
        }
    );

    const MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="map__balloon__shop_name">$[properties.shopName]</div>' +
        '<div class="map__balloon__shop_address">$[properties.shopAddress]</div>' +
        '<div class="map__balloon__shop_phone">$[properties.shopPhone]</div>' +
        '<a class="map__balloon__shop_url" href="$[properties.shopUrl]">$[properties.shopUrlName]</a>'
    );

    const MyClusterIconContentLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="map__balloon__cluster_text">$[properties.geoObjects.length]</div>');

    const MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="map__balloon__pin top">' +
        '<img class="map__balloon__pin__icon" src="https://reverse.wave909.com/themes/custom/weber_base/resources/images/pin.png">' +
        '<img class="map__balloon__pin__shop_icon" src="$[properties.shopIcon]">' +
        '</div>'
    )

    const clusterer = new ymaps.Clusterer({
        clusterIconContentLayout: MyClusterIconContentLayout,
        clusterDisableClickZoom: false,
        clusterNumbers: [5, 10, 20, 30, 50],
        clusterIcons: [
            {
                href: 'https://reverse.wave909.com/themes/custom/weber_base/resources/images/cluster.png',
                size: [50, 50],
                offset: [-25, -25]
            },
            {
                href: 'https://reverse.wave909.com/themes/custom/weber_base/resources/images/cluster.png',
                size: [55, 55],
                offset: [-27, -27]
            },
            {
                href: 'https://reverse.wave909.com/themes/custom/weber_base/resources/images/cluster.png',
                size: [60, 60],
                offset: [-30, -30]
            },
            {
                href: 'https://reverse.wave909.com/themes/custom/weber_base/resources/images/cluster.png',
                size: [65, 65],
                offset: [-32, -32]
            },
            {
                href: 'https://reverse.wave909.com/themes/custom/weber_base/resources/images/cluster.png',
                size: [70, 70],
                offset: [-35, -35]
            }
        ]
    })

    const myMap = new ymaps.Map("store-map", {
        center: [55.76, 37.64],
        zoom: 7,
        controls: []
    });
    myMap.geoObjects.add(clusterer);
    const settings = {
        iconLayout: MyIconContentLayout,
        iconShape: {
            type: 'Rectangle',
            coordinates: [
                [-13, -40], [13, 0]
                // [-50, -100], [50, 0]
            ]
        },
        iconImageOffset: [-13, -40],
        balloonLayout: MyBalloonLayout,
        balloonContentLayout: MyBalloonContentLayout
    }

    //////// GEO
    let cityParam = 'Москва'
    try {
        const result = await ymaps.geolocation.get({
            provider: 'yandex',
            mapStateAutoApply: true,
            autoReverseGeocode: true
        });
        // result.geoObjects.options.set('preset', 'islands#redCircleIcon');
        // result.geoObjects.get(0).properties.set({
        //     balloonContentBody: 'Мое местоположение'
        // });
        // myMap.geoObjects.add(result.geoObjects);
        // console.log(result)
        cityParam = result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName')
    } catch (e) {
        console.error(e)
    }

    const form = $('#shop-search-form')
    form.find('input[type=checkbox]').prop("checked", true)
    // fixme: autocomplete
    const citySelector = $('#city-select')
    citySelector[0].value = cityParam;
    if(citySelector[0].value === "")
        citySelector[0].value = 'Москва'

    const cache = {};
    citySelector.autocomplete({
        minLength:2,
        source: async (request, response) => {
            const {term} = request
            if (term in cache) {
                response(cache[term]);
                return;
            }

            const cities = await fetch(`https://reverse.wave909.com/map-api/cities/autocomplete?q=${term}`).then(r => r.json())
            cache[term] = cities;
            response(cities);
        }
    })

    const load = async () => {
        const formParams = form.serialize()
        const shops = await fetch(`https://reverse.wave909.com/map-api/shops?${formParams}`).then(r => r.json())

        const placemarks = shops.map(shop => new ymaps.Placemark(
            [shop.latitude, shop.longitude],
            shop,
            settings
        ))
        clusterer.removeAll();
        myMap.geoObjects.remove(clusterer)
        if(placemarks.length > 0) {
            myMap.geoObjects.add(clusterer)
            clusterer.add(placemarks);
            let center = averageGeolocation(shops);

            if(shops[0] && shops[0].city === "Новосибирск")
                center = [55.018803, 82.933952]
            myMap.setCenter(center, 10)
        }
    }

    form.submit(e => {
        e.preventDefault();
        load()
    })

    await load()

}
/**
 * Calculate the center/average of multiple GeoLocation coordinates
 * Expects an array of objects with .latitude and .longitude properties
 *
 * @url http://stackoverflow.com/a/14231286/538646
 * @url https://gist.github.com/tlhunter/0ea604b77775b3e7d7d25ea0f70a23eb
 */
function averageGeolocation(shops) {
    if (shops.length === 1) {
        return [shops[0].latitude, shops[0].longitude]
    }

    let x = 0.0
    let y = 0.0
    let z = 0.0

    for (let coord of shops) {
        let latitude = (coord.latitude * Math.PI) / 180
        let longitude = (coord.longitude * Math.PI) / 180

        x += Math.cos(latitude) * Math.cos(longitude)
        y += Math.cos(latitude) * Math.sin(longitude)
        z += Math.sin(latitude)
    }

    const total = shops.length

    x = x / total
    y = y / total
    z = z / total

    let centralLongitude = Math.atan2(y, x)
    let centralSquareRoot = Math.sqrt(x * x + y * y)
    let centralLatitude = Math.atan2(z, centralSquareRoot)

    return [(centralLatitude * 180) / Math.PI, (centralLongitude * 180) / Math.PI]
}


